/** Emerald for profit, rose for loss, plain for zero — same tones as the CFO dashboard chips. */
export function profitClass(profit: number): string {
  if (profit > 0) return 'text-emerald-600 dark:text-emerald-400';
  if (profit < 0) return 'text-rose-600 dark:text-rose-400';
  return '';
}
